import axios from 'axios';

const Api = {
	options: {
		url: Constants.SERVICE_URL || 'https://api.local.dev/'
	},
	strapi: null,

	setOptions(params) {
		this.options = { ...this.options, ...params };
	},

	init() {
		this.strapi = axios.create({
			baseURL: this.options.url,
			timeout: 1000 * 60 * 10
		});
		this.call = this.call.bind(this);
	},

	async call(method, url, params) {
		const self = this;

		return new Promise((resolve, reject) => {
			const options = { method, url, data: params };

			if (localStorage.getItem('token')) {
				const token = localStorage.getItem('token');
				options.headers = {
					...options.headers,
					Authorization: `Bearer ${token}`
				};
			}

			self.strapi(options)
				.then(data => resolve(data))
				.catch((err) => {
					console.error(`Fail to call ${url} :`, err);

					console.log('err', err);
					reject(err.response.data);
				});
		});
	}
};

export default Api;
